
import Vue from "vue";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import { VueTelInput } from "vue-tel-input";
import { mapMutations, mapGetters, mapActions } from "vuex";
import AddressInput from "../components/ship/AddressInput.vue";
import LoaderSpinner from "~/components/LoaderSpinner.vue";
import TravelMap from "~/components/TravelMap.vue";
import LargeSelect from "~/components/form/LargeSelect.vue";
import { Details } from "~/entities/Details";
import Notice from "~/entities/Notice";
import Place from "~/entities/Place";
import { Country, State } from "~/entities/Response/FormData";
import { baseAddress } from "~/pages/youraddresses.vue";
import * as Sentry from "@sentry/vue";

export default Vue.extend({
  components: { AddressInput, LargeSelect, TravelMap, LoaderSpinner },
  data() {
    return {
      title:
        "Bike Shop Finder | Bicycle Shops | Triathlon Shops | Mountain Bike Shops | Bikeflights.com",
      googleObj: null as any,
      trip: {} as any,
      packing: false as boolean,
      bike_case: false as boolean,
      from_to: false as boolean,
      e_bike: false as boolean,
      used_materials: false as boolean,
      mobile_service: false as boolean,
      total: null as any,
      validateInputAddress: false as boolean,
      filtered: null as any,
      serviceFilters: [] as any,
      vueTel: VueTelInput,
      servicesList: [
        {
          name: "NBDA Member",
          id: "mobile",
          value: 7,
        },
        {
          name: "Bikeflights Top Shop",
          id: "mobile",
          value: 8,
        },
        {
          name: "Packing & Assembly",
          id: "packing",
          value: 2,
        },
        {
          name: "Ship From/Ship To",
          id: "ship",
          value: 3,
        },
        {
          name: "Used Boxes & Packing Material",
          id: "boxes",
          value: 1,
        },
        {
          name: "Bike Case Sales or Rentals",
          id: "cases",
          value: 5,
        },
        {
          name: "E-bike Shipping",
          id: "e_bike",
          value: 6,
        },
        {
          name: "Mobile Service",
          id: "mobile",
          value: 4,
        },
      ],
      radius: [
        {
          id: 1,
          label: 5,
        },
        {
          id: 2,
          label: 10,
        },
        {
          id: 3,
          label: 25,
        },
        {
          id: 4,
          label: 50,
        },
        {
          id: 5,
          label: 100,
        },
      ],
      units: [
        {
          id: 2 as number,
          label: "Miles" as string,
        },
        {
          id: 3 as number,
          label: "Kilometers" as string,
        },
      ],
      shopLocation: {
        lat: 0 as any,
        lng: 0 as any,
        range: "" as string,
        units: "" as string,
        errors: {} as any,
        maxResults: 1000 as number,
        types: [] as any[],
      },
      shops: [] as any,
      getServicesForShops: [] as any,
      shopsMarkers: [] as any,
      shopsMarkersKey: "" as string,
      showSaveButton: false,
      savedShops: {} as any,
      rendered: true,
      addresses: [],
      allowedCountries: [] as any,
      allowedStates: {} as any,

      GoogleMaps: null as any,
      GooglePoint: null as any,
      GooglePlaceAutocomplete: null as any,
      GoogleLatLngBounds: null as any,
      googleLibs: null as
        | [
            google.maps.PlacesLibrary,
            google.maps.MapsLibrary,
            google.maps.CoreLibrary,
            google.maps.MarkerLibrary
          ]
        | null,
    };
  },
  async fetch() {
    const _this = this as any;
    await _this.fetchAllowedCountries();
    await _this.fetchAllowedStates();

    _this.allowedCountries = _this.countries
      ?.map((el: Country) => {
        return {
          code: el.code as string,
          name: el.name as string,
          active: el.active as boolean,
          id: el.code as string,
          label: el.name as string,
        };
      })
      .filter((value) => value.active);
    _this.mapStates(_this.states);

    _this.rendered = true;
    if (_this.showSaveButton) {
      const addresses = await _this.requestUserAddresses();
      _this.addresses = addresses?.map((el: any) => {
          return { ...el };
        })
        .sort((a, b) => {
          return a.sortOrder < b.sortOrder
            ? -1
            : a.sortOrder > b.sortOrder
            ? 1
            : 0;
        });
    }
  },
  head() {
    return {
      title: (this as any).title,
      meta: [
        {
          hid: "bicycleshops",
          name: "bicycleshops",
          content:
            "Find a bike shop, and filter results by available services. All shops listed participate in Bikeflights.com’s Bike Shop Shipping Program. Please contact them in advance to coordinate the scheduling and payment of services.",
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      loading: "loading",
      session: "user/session",

      // formData
      countries: "formData/allowedCountries",
      states: "formData/allowedStates",
    }),
    shopsFiltered(): any {
      if (this.serviceFilters.length) {
        const NBDA = this.serviceFilters.includes(7);
        const TopShop = this.serviceFilters.includes(8);
        return this.shops.filter((shop: any) => {
          const a: any = shop.services.filter((service: any) => {
            return this.serviceFilters.includes(service.id);
          });
          return (
            a.length > 0 || (NBDA && shop.nbdaShop) || (TopShop && shop.topShop)
          );
        });
      } else {
        return this.shops;
      }
    },
  },
  watch: {
    session: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (newVal && newVal.sessionType) {
          // when season logs, call to fill the user presets
          (this as any).showSaveButton = true;
        } else {
          (this as any).showSaveButton = false;
        }
      },
    },
    shopsFiltered: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (newVal) {
          for (let i = 0; i < newVal.length; i++) {
            const label = newVal[i].label;
            const postalCode = newVal[i].postalCode;
            for (let j = 0; j < (this as any).addresses.length; j++) {
              if (
                (this as any).addresses[j].displayName === label &&
                (this as any).addresses[j].postalCode === postalCode
              ) {
                (this as any).savedShops[i] = true;
              }
            }
          }
        }
      },
    },
  },
  mounted() {
    this.initMap();
  },
  methods: {
    // Vuex actions
    ...mapMutations({
      pushAlert: "errorsBag/addAlert",
      clearAlert: "errorsBag/clearAlert",
      setLoading: "setLoading",
      setTrip: "ship/setTrip",
      addTrip: "ship/addTrip",
      setDetail: "ship/setDetail",
      flushShipStore: "ship/flush",
      flushPaymentStore: "payment/flush",
    }),
    ...mapActions({
      fetchAllowedCountries: "formData/fetchAllowedCountries",
      fetchAllowedStates: "formData/fetchAllowedStates",
      requestUserAddresses: "user/requestUserAddresses",
    }),
    formatPhoneNumber(phoneNumber) {
      const phoneNumberObject = parsePhoneNumberFromString(phoneNumber);
      if (phoneNumberObject) {
        return phoneNumberObject.formatInternational();
      }
      return phoneNumber;
    },
    toggle() {
      const filter = this.$refs.filters as Element;
      filter.classList.toggle("active");
    },
    mapStates(states: Array<State>) {
      try {
        const _this = this;
        for (let step = 0; step < states.length; step++) {
          const country = states[step].country;
          const countryStates = _this.allowedStates[country];
          if (
            typeof countryStates === "undefined" ||
            (countryStates && countryStates.length === 0)
          ) {
            _this.allowedStates[country] = [];
          }
          const state = {} as State;
          Object.assign(state, states[step]);
          state.id = state.stateprovcode;
          state.label = state.stateprov;
          _this.allowedStates[country].push(state);
        }
        return true;
      } catch (e) {
        return false;
      }
    },
    validateRadius(event: any) {
      this.shopLocation.range = event.label;
    },
    setAddress(type: string, shop: any) {
      // not working? it is never returning lat,long
      try {
        const $: any = this;
        if (shop.country && shop.state && shop.city && shop.postalCode) {
          this.flushShipStore("ship"); // call payment flusher too
          this.flushPaymentStore("ship");
          $.addTrip();
          const place = $.getShopPlace(shop);
          $.setTrip({ direction: type, value: new Place(place), index: 0 });
          const details = $.getShopDetails(shop);
          details.passedAvs = true;
          if (details) {
            $.setDetail({
              direction: type,
              value: new Details(details),
              index: 0,
            });
          }
          $.$router.push("/ship");
        } else if (shop.latitude && shop.longitude) {
          const latLng: google.maps.LatLng = new google.maps.LatLng(
            shop.latitude,
            shop.longitude
          );
          const geocoder = new google.maps.Geocoder();
          geocoder.geocode(
            { location: latLng },
            function (
              results: google.maps.GeocoderResult[] | null,
              status: any
            ) {
              if (status === google.maps.GeocoderStatus.OK) {
                if (results?.[1]) {
                  $.addTrip();
                  $.setTrip({
                    direction: type,
                    value: new Place(results[1]),
                    index: 0,
                  });
                  $.$router.push("/ship");
                }
              }
            }
          );
        }
      } catch (e) {
        Sentry.captureException(e);
      }
    },
    async initMap(): Promise<any> {
      // Initialize
      
      let result: typeof google | null;
      if (window.google && window.google.maps) {
        result = window.google;
      } else {
        const { getGoogleMapsLoader } = await import("~/assets/utils/googleMapsLoader");
        const loader = getGoogleMapsLoader({ apiKey: this.$config.mapsKey });
        result = await loader.load();
      }

      if (!result) return;

      this.googleLibs = [
        result.maps.places,
        result.maps,
        result.maps,
        result.maps.marker,
      ] as unknown as [
        google.maps.PlacesLibrary,
        google.maps.MapsLibrary,
        google.maps.CoreLibrary,
        google.maps.MarkerLibrary
      ];

      const [{ Autocomplete }, { Map }, { Point, LatLngBounds }] =
        this.googleLibs;

      this.GooglePlaceAutocomplete = Autocomplete;
      this.GoogleMaps = Map;
      this.GooglePoint = Point;
      this.GoogleLatLngBounds = LatLngBounds;
    },
    assignLocation(address: google.maps.places.PlaceResult, direction: string) {
      if (address) {
        this.clearAlert(direction + "CountryNotAllowed");
        this.validateInputAddress = false;
        // if the Address is valid then assign to trips
        this.$set(this.trip, direction, address);

        // Assign valid address to parent
        this.$emit("emitTrip", this.trip);

        try {
          if (address.geometry && address.geometry.location) {
            this.shopLocation.lat = address.geometry.location.lat();
            this.shopLocation.lng = address.geometry.location.lng();
          } else {
            this.shopLocation.lat = 0;
            this.shopLocation.lng = 0;
          }
        } catch (e) {
          this.shopLocation.lat = 0;
          this.shopLocation.lng = 0;
        }
      }
    },
    async getShops() {
      if (!this.shopLocation.lat) {
        this.validateInputAddress = true;
        return;
      }
      if (!this.shopLocation.units) {
        Vue.set(this.shopLocation.errors, "units", true);
      }
      if (!this.shopLocation.range) {
        Vue.set(this.shopLocation.errors, "range", true);
      }
      if (this.shopLocation.errors.length > 0) {
        return;
      }
      const axios = require("axios");
      const data = this.shopLocation;
      const config = {
        method: "get",
        url: (this as any).$config.apiURL + "/api/bikeshop/location",
        params: data,
      };
      this.setLoading(true);
      await axios(config)
        .then((response: any) => {
          this.shops = response.data.value;
          this.shopsMarkers = [];
          this.shopLocation.errors = {};
          this.shops.forEach((shop: any, index: any) => {
            // Split hours from shops
            if (shop.hoursFromPlaces) {
              shop.hoursFromPlaces = shop.hoursFromPlaces.split(",");
            }
            // Markers
            this.shopsMarkers.push({
              id: index + 1,
              position: { lat: shop.latitude, lng: shop.longitude },
              label: shop.label,
              company: shop.company,
              postalCode: shop.postalCode,
              address1: shop.address1,
              address2: shop.address2,
              state: shop?.state,
              city: shop?.city,
              phone: shop.phone,
              title: shop.label,
              website: shop?.website,
              opacity: 0.5,
            });
          });
          this.shopsMarkersKey = JSON.stringify(this.shopLocation);
          this.setLoading(false);
        })
        .catch(() => {
          this.setLoading(false);
        });
    },
    getShopPlace(shop: any) {
      
      const place: Place = new Place({});
      place.address_components = [];
      place.formatted_address = "";
      place.geometry = {
        location: {
          lat: () => {
            return shop.latitude ? shop.latitude : 0;
          },
          lng: () => {
            return shop.longitude ? shop.longitude : 0;
          },
        },
        viewport: {
          south: 0,
          west: 0,
          north: 0,
          east: 0,
        },
      } as any;
      place.vicinity = shop && shop.city ? shop.city : "";
      place.company = shop?.company ? shop.company : "";
      place.name = place.company ? place.company : place.vicinity;
      place.html_attributions = [];
      if (shop.country) {
        const country = this.allowedCountries.find(
          (country) => country.code === shop.country
        );
        place.address_components.push({
          long_name: country && country.label ? country.label : shop.country,
          short_name: shop.country,
          types: ["country", "political"],
        });
      }
      if (shop.state) {
        const state =
          this.allowedStates &&
          shop.country &&
          this.allowedStates[shop.country] &&
          this.allowedStates[shop.country]
            ? this.allowedStates[shop.country].find(
                (st) => st.id === shop.state
              )
            : false;
        place.address_components.push({
          long_name: state && state.label ? state.label : shop.state,
          short_name: shop.state,
          types: ["administrative_area_level_1", "political"],
        });
      }
      if (shop.city) {
        place.address_components.push({
          long_name: shop.city,
          short_name: shop.city,
          types: ["locality", "political"],
        });
      }
      if (shop.postalCode) {
        place.address_components.push({
          long_name: shop.postalCode,
          short_name: shop.postalCode,
          types: ["postal_code", "political"],
        });
      }

      if (shop.address1 || shop.streetAddress) {
        place.address_components.push({
          long_name: shop.address1 || shop.streetAddress,
          short_name: shop.address1 || shop.streetAddress,
          types: ["route"],
        });
      }

      if (shop.address2) {
        place.address_components.push({
          long_name: shop.address2.replace("#", ""),
          short_name: shop.address2.replace("#", ""),
          types: ["subpremise"],
        });
      }
      place.formatted_address =
        (shop.address1 ? shop.address1 + ", " : "") +
        (shop.address2 ? shop.address2 + ", " : "") +
        shop.city +
        ", " +
        shop.state +
        " " +
        shop.postalCode +
        ", " +
        shop.country;
      return place;
    },
    getShopDetails(shopAddress: any) {
      const details = {} as any;
      if (shopAddress) {
        if (shopAddress.country) {
          details.country = this.allowedCountries.find(
            (country) => country.code === shopAddress.country
          );
        }
        if (shopAddress.state) {
          details.state =
            this.allowedStates &&
            this.allowedStates[shopAddress.country] &&
            this.allowedStates[shopAddress.country]
              ? this.allowedStates[shopAddress.country].find(
                  (st) => st.id === shopAddress.state
                )
              : shopAddress.state;
        }
        if (shopAddress.company) details.company = shopAddress.company;
        if (shopAddress.firstName) details.firstName = shopAddress.firstName;
        if (shopAddress.lastName) details.lastName = shopAddress.lastName;
        if (shopAddress.address1) details.streetAddress = shopAddress.address1;
        if (shopAddress.address1) details.address1 = shopAddress.address1;
        if (shopAddress.address2) details.address2 = shopAddress.address2;
        if (shopAddress.address3) details.address3 = shopAddress.address3;
        if (shopAddress.city) details.city = shopAddress.city;
        if (shopAddress.phone) details.phone = shopAddress.phone;
        if (shopAddress.postalCode) details.postalCode = shopAddress.postalCode;
      }
      return details;
    },
    async saveAddress(shop: any, index: string) {
      if ((this as any).savedShops[index as string] === 1) {
        return;
      } else {
        (this as any).savedShops[index as string] = 1;
      }
      let country, state;
      if (shop.country) {
        country = this.allowedCountries.find(
          (country) => country.code === shop.country
        );
      }
      if (shop.state) {
        state =
          this.allowedStates &&
          this.allowedStates[shop.country] &&
          this.allowedStates[shop.country]
            ? this.allowedStates[shop.country].find(
                (st) => st.id === shop.state
              )
            : shop.state;
      }
      const newAddress = baseAddress();
      newAddress.displayName = shop.label;
      newAddress.companyName = shop.company;
      newAddress.address1 = shop.address1;
      newAddress.address2 = shop.address2;
      newAddress.address3 = shop.address3;
      newAddress.city = shop.city;
      newAddress.state = state && state.label ? state.label : shop.state;
      newAddress.postalCode = shop.postalCode;
      newAddress.country.code =
        country && country.label ? country.label : shop.country;
      newAddress.phone = shop.phone;
      newAddress.latitude = shop.latitude;
      newAddress.longitude = shop.longitude;
      try {
        const response = await this.$axios.$get(
          `${(this as any).$config.apiURL}/api/Avs`,
          {
            params: {
              company: newAddress.companyName,
              address1: newAddress.address1,
              address2: newAddress.address2,
              city: newAddress.city,
              state: newAddress.state,
              postalCode: newAddress.postalCode,
              countryCode: newAddress.country.code,
            },
          }
        );

        if (response.success) {
          const addressResponse = await this.$axios.$post(
            `${(this as any).$config.apiURL}/api/Address`,
            {
              ...newAddress,
              country: (newAddress.country as any).code,
              passedAvs: response.passedAvs,
              /* @TODO: we can discard these as they are not used in the backend per Travis */
              PostalCodeExt: "ext",
              latitude: "0",
              longitude: "0",
            }
          );
          if (addressResponse) {
            Vue.set(this.savedShops, index, true);
          } else {
            Vue.set(this.savedShops, index, false);
          }
        } else {
          (this as any).actionNotice = new Notice({
            expletive: "Oh Snap",
            message: response.errorMessage,
            type: "alert-danger",
            dismissable: true,
          });
        }
        (this as any).rendered = false;
        (this as any).rendered = true;
      } catch (e) {
        (this as any).actionNotice = new Notice({
          expletive: "Oh Snap",
          message:
            "There was an error adding the new address, please try again",
          type: "alert-danger",
          dismissable: true,
        });
        (this as any).rendered = true;
      }
    },
  },
  fetchOnServer: false,
});
